<template>
  <div class="min-h-screen flex flex-col text-white font-sans relative">
    <StarBackground />
    <NavigationBar />
    <main class="flex-1 relative z-10">
      <router-view />
    </main>
    <SiteFooter />
  </div>
</template>
<script setup>
import NavigationBar from './components/NavigationBar.vue';
import SiteFooter from './components/SiteFooter.vue';
import StarBackground from './components/StarBackground.vue';
</script>